export const PROPERTIES = {
  COMPANY_NAME: 'NuVe System',
  YEAR: '2025',
};
